module.exports = __webpack_public_path__ + "static/zon-the-go2-210bcc67979be0e11943dbe811b0ba43.png";